import { render, staticRenderFns } from "./AvisoTpv.vue?vue&type=template&id=58fe6e14"
import script from "./AvisoTpv.vue?vue&type=script&lang=js"
export * from "./AvisoTpv.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports